import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Grid } from '@mui/material';
import Editor from 'react-simple-code-editor';
import { highlight, languages } from 'prismjs/components/prism-core';
// import 'prismjs/components/prism-javascript';
// import 'prismjs/themes/prism.css'; //Example style, you can use another
import Service from '../../../util/Service';

const steps_VAL = ['Escolha um modelo', 'Escolha um exemplo', 'Implemente sua especificidade'];

export default function NodeTask(props) {
    const { item, processo } = props;

    const [activeStep, setActiveStep] = React.useState(0);
    const [modelos, setModelos] = React.useState();
    const [tipo, setTipo] = React.useState();
    const [exemplos, setExemplos] = React.useState();
    const [exemplo, setExemplo] = React.useState();
    const [code, setCode] = React.useState();
    const [codeExemplo, setCodeExemplo] = React.useState();
    const [steps, setSteps] = React.useState(steps_VAL)

    React.useEffect(()=>{
        if( processo && processo.lstTask){
            console.log( processo.lstTask )
            const i = processo.lstTask.find( t => t.idTask === item.id);
            console.log( i );
            if( i ){
                setTipo( i.tipo );
                setCode( i.code );
            }
        }
    }, [processo]);
    React.useEffect(()=>{
        if( tipo){
            if( tipo === 'VOID'){
                setSteps(['Escolha um modelo', 'Nada'])
            }
        }
    }, [tipo]);
    React.useEffect(()=>{
        if( exemplo){
            Service.FETCH("/api/bpmn/buscaCodigoExemplo/"+exemplo) 
            .then(r => {
                setCodeExemplo(r)
            }); 
        }
    }, [exemplo]);

    React.useEffect(() => {
        console.log(">activeStep<", activeStep)
        if( activeStep === 0){
            if( !modelos) buscaModelos();
        }else if( activeStep === 1){
            buscaModelo();
        }else if( activeStep === 2){
            buscaCodigo();
        }
        
    }, [activeStep]);

    function buscaCodigo(){
        if( !exemplo) return;
        Service.FETCH("/api/bpmn/buscaCodigoExemplo/"+exemplo) 
        .then(r => {
            console.log(r);
            setCode(r)
        });
    }
    function buscaModelo(){
        Service.GET("/api/bpmn/buscaModelo/"+tipo) 
        .then(r => {
            console.log(r);
            setExemplos(r)
        });
    }
    function buscaModelos(){
        Service.GET("/api/bpmn/buscaModelos") 
        .then(r => {
            console.log(r);
            setModelos(r);
        });
    }
    function montaLabelExemplo(nm){
        let txt;
        if( nm ){
            txt = nm.substring(tipo.length+1, nm.length);
            txt = txt.substring(0, txt.length-4)
        }
        return txt;
    }

    const handleStep = (step) => () => {
        setActiveStep(step);        
    };

    const handleComplete = () => {
        const dado = {
            idTask: item.id,
            idProcesso: processo.id,
            tipo: tipo,
            taskType: item.type,
            code: tipo === 'VOID'?null:code
        }
        console.log( dado );
        Service.POST("/api/bpmn/salvarTaskDoProcesso", dado).then(resp => {
            console.log( resp );    
        }).catch(error => {
            console.error(error)
        })
    };

    const MontaStep=()=>{        
        if( activeStep ===  0){
            return (
                <FormControl>
                    <FormLabel id="demo-radio-buttons-group-label">Escolha um modelo</FormLabel>
                    <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"                        
                        name="radio-buttons-group"
                        value={tipo}
                        onChange={(e)=> setTipo(e.target.value)}
                    >
                        <FormControlLabel key={"void"} value="VOID" control={<Radio />} label="VOID" />                  
                        {modelos && modelos.map((m, i)=>
                            <FormControlLabel key={i} value={m} control={<Radio />} label={m.toUpperCase()} />
                        )}      
                    </RadioGroup>
                </FormControl>
            );
        }else if( activeStep ===  1){
            if( tipo === 'VOID'){
                return (
                    <p>Passa para o proximo processo sem executar nada.</p>
                )
            }
            return (
                <Grid container spacing={2}>
                    <Grid item xs={4}>
                        <FormControl>
                            <FormLabel id="exemple">Escolha um exemplo</FormLabel>
                            <RadioGroup
                                aria-labelledby="exemple"
                                name="exemple"
                                value={exemplo}
                                onChange={(e)=> {setExemplo(e.target.value); setCode(''); } }
                            >
                                {exemplos && exemplos.map((m, i)=>
                                    <FormControlLabel key={i} value={m} control={<Radio />} label={ montaLabelExemplo(m) } />
                                )}                        
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    <Grid item xs={8} sx={{ border: '2px solid grey' }}>
                        {codeExemplo && <Editor
                            value={codeExemplo}                            
                            highlight={code => {
                                // return( tipo === 'shell')?highlight(code, languages.bash):highlight(code, languages.js)
                                return highlight(code, languages.js)
                            }}
                            padding={10}
                            style={{
                                fontFamily: '"Fira code", "Fira Mono", monospace',
                                fontSize: 12,
                                minHeight:'400px'
                            }}
                        /> }
                    </Grid>
                </Grid>
            );
        }        
    }

    return (
        <Box sx={{ width: '100%' }}>
            <Stepper nonLinear activeStep={activeStep}>
                {steps.map((label, index) => (
                    <Step key={label} >
                        <StepButton color="inherit" onClick={handleStep(index)}>
                            {label}
                        </StepButton>
                    </Step>
                ))}
            </Stepper>
            <div>
                
                <React.Fragment>
                    <Typography sx={{ mt: 2, mb: 1, py: 1 }}>
                        {activeStep === 0 && "Como gostaria de iniciar o processo?"}
                    </Typography>
                    <MontaStep />
                    { activeStep===2 &&
                        <Editor
                            value={code}
                            onValueChange={t => setCode(t)}
                            highlight={code => {
                                // return( tipo === 'shell')?highlight(code, languages.bash):highlight(code, languages.js)
                                return highlight(code, languages.js)
                            }}
                            padding={10}
                            style={{
                                fontFamily: '"Fira code", "Fira Mono", monospace',
                                fontSize: 12,
                                minHeight:'400px'
                            }}
                        />
                    }
                    <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>

                        <Box sx={{ flex: '1 1 auto' }} />
                        {activeStep === steps.length-1 &&                                
                            <Button onClick={handleComplete}>
                                Salvar
                            </Button>
                        }
                    </Box>
                </React.Fragment>
                
            </div>
        </Box>
    );
}
